import type { MouseEventHandler } from 'react';

import { Typography } from '@sravni/react-design-system';
import { makeReviewLink } from '@sravni/ugc/lib/organizations/linkMakers';
import { OrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import type { CellContext } from '@tanstack/table-core';

import type { OrganizationRatingItem, ProductRatingItem } from '../../../types/rating';

import styles from './columns.module.scss';

export const makeReviewCountColumn =
  ({ filters }: { filters: TFilters }) =>
  <T extends OrganizationRatingItem | ProductRatingItem>(info: CellContext<T, any>) => {
    const { organizationAlias } = info.row.original;
    const { productId } = info.row.original as ProductRatingItem;
    const { organizationType, service } = filters;

    const link = makeReviewLink({
      organizationAlias,
      organizationType,
      serviceAlias: service?.alias,
      productId,
    });

    const handleClick: MouseEventHandler = (e) => {
      e.stopPropagation();

      if (service?.key === 'mortgage' || organizationType === OrganizationTypes.EducationalOrganization) {
        // TODO: удалить костыль после доработки команды ипотеки/эдюкейшн
        return;
      }

      document.location.href = link;
    };

    return (
      <Typography.Text size={14} className={styles.commonColumn} onClick={handleClick}>
        {info.getValue() ?? '—'}
      </Typography.Text>
    );
  };
